/**
 * Reader delivery has its own rollout flag, separate from author generation.
 * Authors may always preview private, already-generated audio.
 */
export const shouldPrepareReaderAudio = ({
  audioAvailable = false,
  isAuthor = false,
  readerFeatureEnabled = false,
} = {}) => Boolean(isAuthor || (readerFeatureEnabled && audioAvailable));
